import React from "react";
import ProxySubnets from "./index";
import { useParams } from "react-router-dom";

export default function ProxyNodeSubnets() {
  let {lid} = useParams();

  return (
    <ProxySubnets
        lid={lid}
    />
  );
}
